/* global.js — minimal vanilla JS for header drawers, cart drawer, predictive search */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ---------- Drawers (mobile nav + cart) ---------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = qs('[data-drawer-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
  }

  qsa('[data-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      var isOpen = target && !target.hidden;
      if (isOpen) {
        closeDrawer(target);
        btn.setAttribute('aria-expanded', 'false');
      } else {
        openDrawer(target);
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) {
      var drawer = e.target.closest('.drawer');
      closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      qsa('.drawer').forEach(function (d) { if (!d.hidden) closeDrawer(d); });
    }
  });

  /* Mobile submenu drill-down */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-drawer-submenu-toggle]');
    if (toggle) {
      var submenu = toggle.nextElementSibling;
      if (submenu) {
        submenu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
    }
    var back = e.target.closest('[data-drawer-submenu-back]');
    if (back) {
      var panel = back.closest('[data-drawer-submenu]');
      if (panel) panel.hidden = true;
    }
  });

  /* Cart icon opens cart drawer when cart_type is "drawer" */
  var cartDrawer = qs('[data-cart-drawer]');
  if (cartDrawer) {
    qsa('[data-cart-icon]').forEach(function (icon) {
      icon.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer(cartDrawer);
      });
    });
  }

  /* ---------- Hero banner slider ---------- */
  qsa('[data-hero-banner]').forEach(function (banner) {
    var slides = qsa('[data-hero-slide]', banner);
    var dots = qsa('[data-hero-dot]', banner);
    if (slides.length < 2) return;
    var current = 0;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function startAutoplay() {
      if (banner.getAttribute('data-autoplay') !== 'true') return;
      var interval = parseInt(banner.getAttribute('data-interval'), 10) || 6000;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    var prevBtn = qs('[data-hero-prev]', banner);
    var nextBtn = qs('[data-hero-next]', banner);
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    startAutoplay();
  });

  /* ---------- Sticky header shadow on scroll ---------- */
  var header = qs('[data-header]');
  if (header && header.classList.contains('header--sticky')) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var current = window.scrollY;
      header.classList.toggle('header--scrolled', current > 8);
      lastScroll = current;
    }, { passive: true });
  }

  /* ---------- Cart quantity + remove (Ajax Cart API) ---------- */
  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer,header')
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        if (sections['cart-drawer']) {
          var parser = new DOMParser();
          var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = newDoc.querySelector('[data-cart-drawer]');
          var currentDrawer = qs('[data-cart-drawer]');
          if (newDrawer && currentDrawer) {
            var wasHidden = currentDrawer.hidden;
            currentDrawer.replaceWith(newDrawer);
            newDrawer.hidden = wasHidden;
          }
        }
        if (sections['header']) {
          var headerParser = new DOMParser();
          var newHeaderDoc = headerParser.parseFromString(sections['header'], 'text/html');
          var newCount = newHeaderDoc.querySelector('[data-cart-count]');
          qsa('[data-cart-count]').forEach(function (el) {
            if (newCount) el.textContent = newCount.textContent;
          });
        }
      })
      .catch(function (err) { console.error('Cart refresh failed', err); });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (res) { return res.json(); });
  }

  function onCartLineChanged(item) {
    if (item.closest('.cart-page__table')) {
      window.location.reload();
    } else {
      refreshCartDrawer();
    }
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-cart-item]');
    if (!item) return;
    var line = parseInt(item.getAttribute('data-line'), 10);
    var input = qs('[data-quantity-input]', item);

    if (e.target.closest('[data-quantity-increase]')) {
      input.value = parseInt(input.value, 10) + 1;
      changeCartLine(line, input.value).then(function () { onCartLineChanged(item); });
    }
    if (e.target.closest('[data-quantity-decrease]')) {
      input.value = Math.max(0, parseInt(input.value, 10) - 1);
      changeCartLine(line, input.value).then(function () { onCartLineChanged(item); });
    }
    if (e.target.closest('[data-cart-remove]')) {
      changeCartLine(line, 0).then(function () { onCartLineChanged(item); });
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-quantity-input]')) {
      var item = e.target.closest('[data-cart-item]');
      var line = parseInt(item.getAttribute('data-line'), 10);
      changeCartLine(line, Math.max(0, parseInt(e.target.value, 10) || 0)).then(function () { onCartLineChanged(item); });
    }
  });

  /* Intercept "Add to cart" forms to add via Ajax and open drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        refreshCartDrawer();
        if (cartDrawer) openDrawer(cartDrawer);
      })
      .catch(function (err) { console.error('Add to cart failed', err); });
  });

  /* ---------- Product page: gallery, variant picker, quantity, tabs ---------- */
  qsa('[data-product-section]').forEach(function (section) {
    var form = qs('[data-product-form]', section);
    var variantIdInput = qs('[data-variant-id]', form);
    var optionSelectors = qsa('[data-option-selector]', form);
    var addBtn = qs('[data-add-to-cart]', section);
    var availabilityEl = qs('[data-product-availability]', section);
    var priceEl = qs('[data-price]', section);

    /* Gallery */
    qsa('[data-gallery-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        qsa('[data-gallery-slide]', section).forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === id);
        });
        qsa('[data-gallery-thumb]', section).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* Variant picker: fetch variant data and update price/availability/id */
    if (optionSelectors.length && window.__productData === undefined) {
      window.__productData = {};
    }

    function getSelectedOptions() {
      return optionSelectors
        .sort(function (a, b) {
          return a.closest('[data-option-position]').getAttribute('data-option-position') - b.closest('[data-option-position]').getAttribute('data-option-position');
        })
        .map(function (sel) { return sel.value; });
    }

    optionSelectors.forEach(function (selector) {
      selector.addEventListener('change', function () {
        var productUrl = section.getAttribute('data-product-url');
        fetch(productUrl + '.js')
          .then(function (res) { return res.json(); })
          .then(function (productData) {
            var selectedOptions = getSelectedOptions();
            var match = productData.variants.find(function (v) {
              return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
            });
            if (!match) return;
            if (variantIdInput) variantIdInput.value = match.id;
            if (availabilityEl) {
              availabilityEl.textContent = match.available ? availabilityEl.getAttribute('data-in-stock-label') || 'In Stock' : 'Sold Out';
              availabilityEl.classList.toggle('product__availability--in-stock', match.available);
            }
            if (addBtn) {
              addBtn.disabled = !match.available;
              var textEl = qs('[data-add-to-cart-text]', addBtn);
              if (textEl) textEl.textContent = match.available ? textEl.getAttribute('data-available-label') || 'Add to Basket' : 'Sold Out';
            }
            if (priceEl) {
              var current = qs('[data-price-current]', priceEl);
              if (current && match.price != null) {
                current.textContent = formatMoney(match.price);
              }
            }
          })
          .catch(function (err) { console.error('Variant fetch failed', err); });
      });
    });

    /* Quantity stepper (scoped to product form, not cart drawer) */
    var qtyWrap = qs('.product__quantity', section);
    if (qtyWrap) {
      var qtyInput = qs('[data-quantity-input]', qtyWrap);
      var decreaseBtn = qs('[data-quantity-decrease]', qtyWrap);
      var increaseBtn = qs('[data-quantity-increase]', qtyWrap);
      if (decreaseBtn) decreaseBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
      if (increaseBtn) increaseBtn.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    /* Tabs */
    var tabs = qs('[data-tabs]', section);
    if (tabs) {
      qsa('[data-tab-trigger]', tabs).forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var target = trigger.getAttribute('data-tab-trigger');
          qsa('[data-tab-trigger]', tabs).forEach(function (t) { t.classList.remove('is-active'); });
          qsa('[data-tab-panel]', tabs).forEach(function (p) { p.classList.remove('is-active'); });
          trigger.classList.add('is-active');
          var panel = qs('[data-tab-panel="' + target + '"]', tabs);
          if (panel) panel.classList.add('is-active');
        });
      });
    }
  });

  function formatMoney(cents) {
    var format = window.themeMoneyFormat || '£{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- Wish list (localStorage-backed) ---------- */
  var WISHLIST_KEY = 'wex-wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }

  function setWishlist(ids) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
  }

  function syncWishlistButtons() {
    var ids = getWishlist();
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.setAttribute('aria-pressed', ids.indexOf(id) !== -1 ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    var ids = getWishlist();
    var index = ids.indexOf(id);
    if (index === -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    setWishlist(ids);
    syncWishlistButtons();
  });

  syncWishlistButtons();

  /* ---------- Collection filters (mobile drawer + collapsible groups) ---------- */
  var filtersPanel = qs('[data-filters]');
  if (filtersPanel) {
    qsa('[data-filters-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        filtersPanel.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
    qsa('[data-filters-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        filtersPanel.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  qsa('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = btn.nextElementSibling;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (body) body.hidden = expanded;
    });
  });

  /* Auto-submit filter checkboxes */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-filter-input]')) {
      var form = e.target.closest('[data-filters-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });

  /* Grid / list view toggle */
  var viewToggle = qs('[data-view-toggle]');
  if (viewToggle) {
    var grid = qs('[data-product-grid]');
    viewToggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-view]');
      if (!btn || !grid) return;
      qsa('[data-view]', viewToggle).forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      grid.classList.toggle('view--list', btn.getAttribute('data-view') === 'list');
    });
  }

  /* ---------- Predictive search ---------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-predictive-search] input[type="search"]')) return;
    var form = e.target.closest('[data-predictive-search]');
    var resultsEl = qs('[data-predictive-search-results]', form);
    var query = e.target.value.trim();

    clearTimeout(searchTimer);
    if (query.length < 2) {
      if (resultsEl) resultsEl.hidden = true;
      return;
    }

    searchTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!resultsEl) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            resultsEl.innerHTML = '<p class="predictive-search-empty">' + 'No results found' + '</p>';
          } else {
            resultsEl.innerHTML = products.map(function (p) {
              return '<a class="predictive-search-item" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '" alt="" width="48" height="48" loading="lazy">' : '') +
                '<span>' + p.title + '</span>' +
                '</a>';
            }).join('');
          }
          resultsEl.hidden = false;
        })
        .catch(function (err) { console.error('Predictive search failed', err); });
    }, 250);
  });

  document.addEventListener('click', function (e) {
    qsa('[data-predictive-search-results]').forEach(function (el) {
      if (!el.hidden && !e.target.closest('[data-predictive-search]')) {
        el.hidden = true;
      }
    });
  });
})();
